module.exports = __webpack_public_path__ + "img/Butterfly_00209.5f5e6810.png";